import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-primary">
      <div className="text-center">
        <h1 className="mb-4 text-6xl font-bold text-white">404</h1>
        <p className="mb-8 text-xl text-white/90">Página não encontrada</p>
        <Link
          to="/dashboard"
          className="inline-block rounded bg-white px-4 py-2 font-bold text-primary transition duration-200 hover:bg-neutral-100"
        >
          Voltar ao Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
